import { render } from "./MerRectDispWeb.vue?vue&type=template&id=897a8f20&scoped=true"
import script from "./MerRectDispWeb.vue?vue&type=script&lang=js"
export * from "./MerRectDispWeb.vue?vue&type=script&lang=js"

import "./MerRectDispWeb.vue?vue&type=style&index=0&id=897a8f20&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897a8f20"]])

export default __exports__